export function cardStyle(cardBg, accentColor, isDark = true) {
  return {
    borderRadius: '16px',
    background: `linear-gradient(135deg, ${accentColor}14 0%, ${accentColor}04 100%)`,
    border: `1px solid ${accentColor}30`,
  };
}

export function cardInnerStyle(isDark = true) {
  return {};
}
